module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiMwMGNkMDAiIGQ9Ik0zNDEuNDYgMGgxNzAuNTMzdjUxMS45ODRIMzQxLjQ2eiIvPgogICAgPHBhdGggZmlsbD0iI2ZmOWEwMCIgZD0iTTAgMGgxNzAuM3Y1MTEuOTg0SDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMTcwLjMgMGgxNzEuMTZ2NTExLjk4NEgxNzAuM3oiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/ci.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/ci.svg
// module chunks = 0